const nbsp = "\u0020";

/**
 * @param {string} s
 * @return {string}
 */
export const wrapWithSpace = (s) => `${nbsp}${s}${nbsp}`;
